// extracted by mini-css-extract-plugin
export default {"container":"_yAevdMYbRqyvcB","title":"l2ecXdK9gkW8oQL","annotation":"MyRNqd285DV3kbY","button-container":"cZAKfgDciSttNTF","continue-button":"S26SkIHKVjP3TPL"};